export const PROCUREMENT_UNIT_STATUSES = [
  "CREATED",
  "IN_TRANSIT",
  "IN_INVENTORY",
  "SOLD",
  "LOST_IN_TRANSIT",
  "COUNT_ADJUSTMENT",
  "CUSTOMER_SUPPORT",
  "DAMAGED",
  "DAMAGED_RECOVERED",
  "CANCELLED",
] as const;

export type ProcurementUnitStatus = (typeof PROCUREMENT_UNIT_STATUSES)[number];

export const PROCUREMENT_COST_SOURCES = ["LEGACY", "PURCHASE_PRICE", "MARKET_PRICE"] as const;
export type ProcurementCostSource = (typeof PROCUREMENT_COST_SOURCES)[number];

export const SUPPORT_REASONS = ["RESHIPMENT", "VIP", "MARKETING", "OTHER"] as const;
export type SupportReason = (typeof SUPPORT_REASONS)[number];

export const DAMAGE_ORIGINS = ["IN_TRANSIT", "IN_INVENTORY", "RETURNED"] as const;
export type DamageOrigin = (typeof DAMAGE_ORIGINS)[number];

export const BUYING_ORDER_STATUSES = ["ORDERED", "CANCELLED"] as const;
export type BuyingOrderStatus = (typeof BUYING_ORDER_STATUSES)[number];

export const BUYING_ORDER_SOURCES = ["INTERNAL", "BUYLIST"] as const;
export type BuyingOrderSource = (typeof BUYING_ORDER_SOURCES)[number];

export const BUYLIST_ORDER_STATUSES = [
  "submitted",
  "negotiating",
  "rejected",
  "cancelled",
  "approved",
  "invoice_submitted",
  "invoice_rejected",
  "invoice_approved",
  "shipped",
  "arrived",
  "qc_completed",
  "completed",
  "payment_sent",
] as const;
export type BuylistOrderStatus = (typeof BUYLIST_ORDER_STATUSES)[number];

/** Statuses that count as on-hand facility stock. */
export const ON_HAND_STATUSES: readonly ProcurementUnitStatus[] = ["IN_INVENTORY"];

export const ALLOWED_UNIT_TRANSITIONS: Record<
  ProcurementUnitStatus,
  readonly ProcurementUnitStatus[]
> = {
  CREATED: ["IN_TRANSIT", "IN_INVENTORY", "CANCELLED"],
  IN_TRANSIT: ["IN_INVENTORY", "DAMAGED", "LOST_IN_TRANSIT", "CANCELLED"],
  IN_INVENTORY: ["SOLD", "COUNT_ADJUSTMENT", "CUSTOMER_SUPPORT", "DAMAGED"],
  COUNT_ADJUSTMENT: ["IN_INVENTORY", "DAMAGED"],
  CUSTOMER_SUPPORT: [],
  DAMAGED: ["DAMAGED_RECOVERED"],
  DAMAGED_RECOVERED: ["IN_INVENTORY"],
  SOLD: ["DAMAGED", "IN_INVENTORY"],
  LOST_IN_TRANSIT: [],
  CANCELLED: ["CREATED", "IN_TRANSIT"],
};

export function canTransitionUnit(from: ProcurementUnitStatus, to: ProcurementUnitStatus): boolean {
  return ALLOWED_UNIT_TRANSITIONS[from].includes(to);
}
